<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">		
		<div class="header-container">
			<HeaderVR />
		</div>
		<div id="content" class="content" ref="content">
			<h1>直播节目</h1>
			<video ref="videoPlayer" class="video-js vjs-big-play-centered" controls style="width:80%;height:80%;object-fit:contain;"></video>
            <div>状态: {{ statusMessage }}</div>
            <div v-if="errorMessage" class="error">错误: {{ errorMessage }}</div>
            <button @click="startTranscode" :disabled="isTranscoding">开始转码</button>
		</div>
		<Footer/>
	</div>
</template>

<script>
	import rtmp_new from './rtmp_new_controller';
	export default rtmp_new;
</script>

<style src="@/assets/css/rtmp.css" scoped></style>
<!-- 这段全局css代码在related_news_detail.vue,subject_detail.vue,tail_detail.vue都有，而且相同。 -->
<style>
/*.ar-content .html-content p img{
	width:86%!important;
	max-width:800px;
	object-fit: contain;
}
@media screen and (max-width: 767px) {
	.ar-content .html-content p img{
		width:100%!important;
		max-width:375px!important;
		height:auto!important;
	}
}*/
</style>

